import Vue from 'vue';
import SimpleVueValidation from 'simple-vue-validator';
import util from "@/mixins/util";
const Validator = SimpleVueValidation.Validator;

Vue.use(SimpleVueValidation);

export default {
    data() {
        return {
            title:'',
            content:'',
            date:'',
            files:[],
            langOption:30,
            wid: '',
            wp_id: '',
            be_start:'',
            be_end:'',
            type:2,
            memberList:[],
            sid : '',
            bid: '',

            moveRoute: '',
            hasRequiredMoveRouteKey: false,
            moveRouteKey: '',
        }
    },
    validators: {
        title: function (value) {
            return Validator.value(value)
                .required('제목을 입력해 주세요.')
        },

        date:function (value) {
            return Validator.value(value)
                .required('작성일을 선택해 주세요.')
        },
        content: function (value) {
            return Validator.value(value)
                .required('내용을 입력해 주세요.')
        },
        files: function (value) {
            return Validator.value(value)
                .required('이미지를 선택해 주세요.')
        },
        langOption: function (value) {
            return Validator.value(value)
        },
        wid: function (value) {
            return Validator.value(value)
        },
        wp_id: function (value) {
            return Validator.value(value)
        },
        be_start: function (value) {
            return Validator.value(value)
                .required('시작날짜를 선택해 주세요.')
        },
        memberList: function (value) {
            return Validator.value(value)
                .required('회원을 선택해 주세요.')
        },
        type: function (value) {
            return Validator.value(value)
        },
        be_end: function (value) {
            return Validator.value(value)
        },
        sid: function (value) {
            return Validator.value(value)
        },
        bid: function (value) {
            return Validator.value(value)
        },
        moveRoute: function (value) {
            return Validator.value(value)
        },
        moveRouteKey: function (value) {
            return Validator.value(value)
                .custom(() => {
                    if(this.hasRequiredMoveRouteKey && util.isEmpty(value)) {
                        return '이동경로를 선택해주세요.';
                    }
                })
        },
    }
}
